import { all, fork } from "redux-saga/effects";
import { informationPageSaga } from "./information/saga";
import { projectListSaga } from "./project-list/project-list-saga";
import { addEditProjectDialogSaga } from "./project-list/components/add-edit-project-dialog/add-edit-project-dialog-saga";
import { employeeInformationSaga } from "./contact/contact-info-saga";
import { faqSaga } from "./faq/faq-saga";
import { profileSaga } from "./profile/saga";
import { priceListSaga } from "./price-list/price-list-saga";
import { productDetailsSaga } from "./product-details/product-details-saga";
import { combinedConfiguratorSaga } from "./configurator/saga";
import { configureProductSaga } from "./configure-product/configure-product-saga";
import { bulkConfigureProductsSaga } from "./bulk-configure-products/bulk-configure-products-saga";

export function* pageSaga() {
  yield all([
    fork(informationPageSaga),
    fork(projectListSaga),
    fork(addEditProjectDialogSaga),
    fork(employeeInformationSaga),
    fork(faqSaga),
    fork(profileSaga),
    fork(priceListSaga),
    fork(productDetailsSaga),
    fork(combinedConfiguratorSaga),
    fork(configureProductSaga),
    fork(bulkConfigureProductsSaga)
  ]);
}
